import { render, staticRenderFns } from "./Biography.vue?vue&type=template&id=49c1b2f7&scoped=true&"
import script from "./Biography.vue?vue&type=script&lang=js&"
export * from "./Biography.vue?vue&type=script&lang=js&"
import style0 from "./Biography.vue?vue&type=style&index=0&id=49c1b2f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1b2f7",
  null
  
)

export default component.exports